import React from "react";
import { Typography } from "antd";
import type { ReactNode } from "react";
import type { TitleProps } from "antd/es/typography/Title";

type Props = {
  level?: TitleProps["level"];
  children: ReactNode;
};

const Title = ({
  level = 5,
  children,
}: Props): JSX.Element => {
  return (
    <Typography.Title level={level} style={{ marginTop: 0 }}>
      {children}
    </Typography.Title>
  );
};

export default Title;
